module.exports = __webpack_public_path__ + "static/media/alim2021.6e1e7d38.png";